import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "tpm-notice",
  templateUrl: "./notice.component.html",
  styleUrls: ["./notice.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, MatIconModule],
  host: {
    class: "notice",
    "[class.notice--warning]": "variant === 'warning'",
    "[class.notice--error]": "variant === 'error'",
    "[class.notice--has-icon]": "!!icon",
    "[class.notice--has-heading]": "!!heading"
  }
})
export class NoticeComponent {
  @Input() public icon: string | null = null;
  @Input() public heading: string | null = null;
  @Input() public variant: "info" | "warning" | "error" = "info";
}
